package one.healthium.domain.health_log.models

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class HealthLogModel(
    val id: String,
    val date: Instant,
    val answers: List<HealthLogEntryModel>,
)

@Serializable
data class HealthLogEntryModel(
    val questionId: String,
    val answers: List<HealthLogAnsModel>,
)

@Serializable
data class HealthLogAnsModel(
    val answerId: String,
    val weight: Int,
)